module.exports = __webpack_public_path__ + "img/happiness.7928fc61.svg";